// Change ONLY this line to switch entire app
export const ACTIVE_MODEL = "rank"; 
// "return" | "rank"

export const MODEL_CONFIG = {
  return: {
    label: "Return Based",
    profitabilityTab: "profitability",
  },
  rank: {
    label: "Rank Based",
    profitabilityTab: "Quality",
  },
};